'use client';

import { useCallback, useState } from 'react';

export type CoPilotDevToolId = 'token-usage' | 'filesystem' | 'agent-messages';

export function useCoPilotDevTools() {
  const [activeTool, setActiveTool] = useState<CoPilotDevToolId | null>(null);

  const toggleTool = useCallback((tool: CoPilotDevToolId) => {
    setActiveTool((current) => (current === tool ? null : tool));
  }, []);

  const closeTool = useCallback((tool: CoPilotDevToolId) => {
    setActiveTool((current) => (current === tool ? null : current));
  }, []);

  const closeAllTools = useCallback(() => {
    setActiveTool(null);
  }, []);

  return {
    activeTool,
    isTokenUsageOpen: activeTool === 'token-usage',
    isFilesystemOpen: activeTool === 'filesystem',
    isAgentMessagesOpen: activeTool === 'agent-messages',
    toggleTool,
    closeTool,
    closeAllTools,
  };
}
